import { render } from "./ChatApprove.vue?vue&type=template&id=b37f7e1e"
import script from "./ChatApprove.vue?vue&type=script&lang=js"
export * from "./ChatApprove.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ChatApprove.vue?vue&type=style&index=1&id=b37f7e1e&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__